module.exports = __webpack_public_path__ + "img/38.808b8e4b.webp";